module.exports = __webpack_public_path__ + "img/profile-picture.3c4d598c.png";